import React from 'react';
import { SummaryItem } from '../../../../../shared/Summary/SummaryItem/SummaryItem';
import { useSelectCurrentOrder } from '../../../../../../selectors/order/selectCurrentOrder';
import { EmdDisplayAndAcornPasscodeGenerator } from './EmdDisplayAndAcornPasscodeGenerator';
import { eTransactionCategory } from '../../../../../../ui-toolkit/enums/eTransactionType';

export const EMDAmount: React.FC = () => {
  const { data } = useSelectCurrentOrder();

  if (data.transaction.transaction_category !== eTransactionCategory.Purchase) {
    return null;
  }

  return (
    <SummaryItem label={'Earnest Money Deposit'} tab={'summary'}>
      <EmdDisplayAndAcornPasscodeGenerator />
    </SummaryItem>
  );
};
